import * as React from 'react'
import { IconsModel } from '../types/iconsModel'

const SvgGardien = (
	{
		color,
		width = 45,
		height = 35
	}: IconsModel
) => (
	<svg
		id="gardien_svg__FULL_VECTO_SEUL"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 425.2 425.2"
		width={width}
		height={height}
	>
		<defs>
			<style>{`.prestation_cls_fill{fill:${color}`}</style>
		</defs>
		<path
			className="prestation_cls_fill"
			d="M297.52 364.06h-63.69v-9.99h63.69c8.95 0 16.24-7.28 16.24-16.24v-71.4c0-28.47-23.16-51.62-51.62-51.62h-15.23l-34.31 44.67-34.31-44.67h-15.23c-28.47 0-51.62 23.16-51.62 51.62v71.4c0 8.95 7.28 16.24 16.24 16.24h63.69v9.99h-63.69c-14.46 0-26.22-11.76-26.22-26.22v-71.4c0-33.97 27.64-61.61 61.61-61.61h20.15l29.39 38.26L242 204.83h20.15c33.97 0 61.61 27.64 61.61 61.61v71.4c0 14.46-11.76 26.22-26.22 26.22Z"
		/>
		<path
			className="prestation_cls_fill"
			d="M281.29 300.37h-52.45v-31.22h52.45v31.22Zm-42.46-9.99h32.48v-11.25h-32.48v11.25ZM212.6 193.74c-36.56 0-66.3-29.74-66.3-66.3s29.74-66.3 66.3-66.3 66.3 29.74 66.3 66.3-29.74 66.3-66.3 66.3Zm0-122.62c-31.05 0-56.32 25.26-56.32 56.32s25.26 56.32 56.32 56.32 56.32-25.26 56.32-56.32-25.26-56.32-56.32-56.32Z"
		/>
		<path
			className="prestation_cls_fill"
			d="M214.17 163.39c-13.47 0-24.57-4.64-30.46-12.72l-2.94-4.04 8.07-5.88 2.94 4.04c3.93 5.39 12.3 8.61 22.39 8.61s17.7-5.04 22.08-9.26l3.59-3.47 6.94 7.18-3.59 3.47c-8.05 7.78-18.36 12.07-29.02 12.07ZM207.37 116.92h-9.99c0-2.88-2.34-5.22-5.22-5.22s-5.22 2.34-5.22 5.22h-9.99c0-8.39 6.82-15.21 15.21-15.21s15.21 6.82 15.21 15.21ZM248.25 116.92h-9.99c0-2.88-2.34-5.22-5.23-5.22s-5.23 2.34-5.23 5.22h-9.99c0-8.39 6.82-15.21 15.21-15.21s15.21 6.82 15.21 15.21Z"
		/>
	</svg>
)
export default SvgGardien
